<template>
  <v-card>
    <v-form>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs11 md10>
            <v-textarea
              v-model="message.content"
              label="Mensaje"
              placeholder="Escribe tu mensaje..."
              auto-grow
              outline
              rows="2"
              color="success"
              hide-details
            ></v-textarea>
          </v-flex>

          <v-flex xs1 md2 align-self-center>
            <v-btn small outline fab color="indigo" @click="onPickFile">
              <v-icon>attach_file</v-icon>
            </v-btn>
            <input
              type="file"
              style="display: none"
              ref="fileInput"
              multiple="true" 
              accept="*/*"
              @change="setFiles()"
            />
          </v-flex>

          <v-flex xs12 md12>
            <p v-if="message.files.length === 1" class="my-auto">{{ message.files.length }} archivo adjunto </p>
            <p v-else class="my-auto">{{ message.files.length }} archivos adjuntos </p>

            <v-btn 
              class="ml-0" 
              color="success" 
              :disabled="!message.content.length || loading"
              @click="handleCreateMessage()"
            >
              <v-progress-circular
                :size="20"
                indeterminate
                color="success"
                class="mr-1"
                v-show="loading"
              ></v-progress-circular>
              Responder
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      message: {
        content: '',
        files: []
      },
      loading: false,
    }
  },
  props: {
    getTicket: { type: Function, required: true },
  },
  methods: {
    ...mapActions("helpcenter", ["fetchTicket", "createMessage"]),
    async handleCreateMessage() {
      this.loading = true
      const formData = this.setFormData()
      const payload = { ticketId: this.$route.params.id, formData }
      const res = await this.createMessage(payload)

      if (res.success) {
        this.message.content = ""
        this.message.files = []
        this.getTicket()
      }
      
      this.loading = false
    },
    setFormData() {
      const formData = new FormData()
      formData.append("message[content]", this.message.content)
      for (let file of this.message.files) {
        formData.append("message[files][]", file);
      }
      return formData
    },
    onPickFile () {
      this.$refs.fileInput.click()
    },
    setFiles() {
      this.message.files = this.$refs.fileInput.files
    }
  },
}
</script>
<style>
  
</style>